// Rótulo da versão de fluxo que uma execução rodou (#1705). Um lugar só para as
// três telas que o mostram (aba Execuções, detalhe da execução e a listagem da
// conversa/contato) não dizerem a mesma coisa de jeitos diferentes.
//
// A versão de TESTE (`sandbox`) tem `version_number` 0 no backend; mostrar "Versão 0"
// faria parecer uma publicação. Sem versão (contrato antigo) sai vazio.
export const flowVersionLabel = (version, t) => {
  if (!version) return '';
  if (version.sandbox) return t('AUTOMATION_FLOWS.VERSION_LABEL.SANDBOX');
  return t('AUTOMATION_FLOWS.VERSION_LABEL.NUMBER', {
    number: version.version_number,
  });
};

// Rota da visualização somente leitura de uma versão (#1705). Mora aqui, ao
// lado do rótulo, pelo mesmo motivo: as telas que mostram "Versão N" são as que
// linkam para ela, e a regra de QUANDO linkar tem de ser uma só.
export const FLOW_VERSION_ROUTE = 'automation_flows_version';

// A versão de TESTE não vira link: ela é uma linha por fluxo, reescrita a cada
// Testar, e o backend a recusa (404). Sem versão também não há para onde ir.
export const flowVersionRoute = ({ accountId, flowId, version }) => {
  if (!version || version.sandbox || !version.id || !flowId) return null;
  return {
    name: FLOW_VERSION_ROUTE,
    params: { accountId, flowId, versionId: version.id },
  };
};

export default flowVersionLabel;
